import { render } from "./SmWarningIcon.vue?vue&type=template&id=170b3a17&scoped=true"
const script = {}

import "./SmWarningIcon.vue?vue&type=style&index=0&id=170b3a17&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-170b3a17"]])

export default __exports__